import useCurrentUser from './useCurrentUser';
import { parseAreaRole, type AreaRole } from '@endurance/platform-contracts';

export type { AreaRole } from '@endurance/platform-contracts';

const useCurrentUserRoles = (): Array<AreaRole> => {
  const [currentUser] = useCurrentUser();
  const areasAndRoles = currentUser && currentUser.idTokenClaims && currentUser.idTokenClaims.roles;

  if (!areasAndRoles) return [];

  const roles = areasAndRoles.map(parseAreaRole);

  return roles;
};

export default useCurrentUserRoles;
